module.exports = __webpack_public_path__ + "img/spinner.5697d29f.png";